/* @flow */
import React from 'react';

import TBody from 'components/UIKit/Table/TBody';
import SamplesRow from './SamplesRow';

let SamplesRows = ({
  children, router
}: any): React.Element => (
  TBody({
    children: children.map(sample => (
      <SamplesRow
        key={ sample.id }
        router={ router }
      >
        { sample }
      </SamplesRow>
    ))
  })
);

export default SamplesRows;
